<template>
  <section class="app-component">
    <tc-header :page="page" :access_token="access_token"></tc-header>
    <tc-title :title="title" :back_page="back_page"></tc-title>
    <main>
      <TcWelcome          v-if="page=='welcome'"></TcWelcome>
      <TcLoginDni         v-else-if="page=='login-dni'"></TcLoginDni>
      <TcLoginPublic      v-else-if="page=='login-public'"></TcLoginPublic>
      <TcLogin            v-else-if="page=='login'"></TcLogin>
      <TcHome             v-else-if="access_token && page=='home'"></TcHome>
      <TcNewAppointment   v-else-if="access_token && page=='new-appointment'"></TcNewAppointment>
      <TcMyAppointments   v-else-if="access_token && page=='my-appointments'"></TcMyAppointments>
      <TcCalendar         v-else-if="access_token && page=='calendar'"></TcCalendar>
      <TcEventsList       v-else-if="access_token && page=='events-list'"></TcEventsList>
      <TcEventsMyCalendar v-else-if="access_token && page=='events-my-calendar'"></TcEventsMyCalendar>
      <TcEventInscription v-else-if="access_token && page=='inscription' && $root.selected_event" :event="$root.selected_event"></TcEventInscription>
      <TcTest             v-else-if="page=='test'"></TcTest>
    </main>
  </section>
</template>

<script>
import TcHeader from './TcHeader.vue';
import TcTitle from './TcTitle.vue';
import TcWelcome from './TcWelcome.vue';
import TcLoginDni from './TcLoginDni.vue';
import TcLoginPublic from './TcLoginPublic.vue';
import TcLogin from './TcLogin.vue';
import TcHome from './TcHome.vue';
import TcNewAppointment from './TcNewAppointment.vue';
import TcMyAppointments from './TcMyAppointments.vue';
import TcCalendar from './TcCalendar.vue';
import TcEventsList from './TcEventsList.vue';
import TcEventsMyCalendar from './TcEventsMyCalendar.vue';
import TcEventInscription from './TcEventInscription.vue';
import TcTest from './TcTest.vue';

export default {
  name: 'AppComponent',
  props: ['access_token','init_page','page','title','back_page'],
  components: {
    TcTitle,
    TcHeader,
    TcWelcome,
    TcLoginDni,
    TcLoginPublic,
    TcLogin,
    TcHome,
    TcNewAppointment,
    TcMyAppointments,
    TcCalendar,
    TcEventsList,
    TcEventsMyCalendar,
    TcEventInscription,
    TcTest,
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted() {
    //console.log('MOUNTED APP', this);
  },
  created() {
    //console.log('CREATED APP', this);
    this.$root.setPage(this.init_page);
  }

}
</script>
